import React, { useState, useRef, useEffect } from "react";
import { Globe } from "lucide-react";
import { LOCALES } from "@/lib/i18n";
import { useI18n } from "@/context/I18nContext";

export default function LangSwitcher() {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const current = LOCALES[lang];

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="lang-switcher"
        onClick={() => setOpen((v) => !v)}
        className="h-9 px-3 border border-[var(--voix-border)] text-slate-400 hover:border-cyan-500 hover:text-cyan-300 flex items-center gap-2 font-mono-tech text-[10px] uppercase tracking-widest transition"
      >
        <Globe size={12} />
        <span>{current.flag}</span>
        <span className="hidden md:inline">{lang.toUpperCase()}</span>
      </button>
      {open && (
        <div
          data-testid="lang-menu"
          className="absolute right-0 top-full mt-2 min-w-[160px] border border-white/10 bg-[#0a0a0a] shadow-2xl z-50"
        >
          {Object.entries(LOCALES).map(([code, info]) => (
            <button
              key={code}
              data-testid={`lang-option-${code}`}
              onClick={() => { setLang(code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-3 py-2.5 font-mono-tech text-[11px] uppercase tracking-widest transition ${
                lang === code ? "text-cyan-300 bg-cyan-500/10" : "text-slate-400 hover:text-white hover:bg-white/5"
              }`}
            >
              <span className="text-base leading-none">{info.flag}</span>
              <span>{info.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
